import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';
import Header from '../../shared/Header';
import Splash from '../../shared/Splash';
import BannerSplash from '../../../assets/banner.jpg';
import Footer from '../../shared/Footer';
import Post from './Post';
import { Column } from '../../theme/index';

const POSTS_PER_PAGE = 4;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledColumn = styled(Column)`
  width: 55%;
  margin: 3em auto;
  @media (max-width: 720px) {
    width: 90%;
  }
`;

const Resources = ({
  data: { loading, error, posts, postsConnection },
  loadMorePosts,
}) => {
  if (posts && postsConnection) {
    const areMorePosts = posts.length < postsConnection.aggregate.count;
    return (
      <Wrapper>
        <Header />
        <Splash
          img={BannerSplash}
          text={['Resources', 'Learn more about your expertise']}
        />
        <StyledColumn width="55%" margin="3em auto">
          {posts.map((post, i) => (
            <Post post={post} key={i} />
          ))}
        </StyledColumn>
        <div className="Home-showMoreWrapper">
          {areMorePosts ? (
            <button
              className="Home-button"
              disabled={loading}
              onClick={() => loadMorePosts()}
            >
              {loading ? 'Loading...' : 'Show More Posts'}
            </button>
          ) : (
            ''
          )}
        </div>
        <Footer />
      </Wrapper>
    );
  } else {
    return null;
  }
};

export const posts = gql`
  query posts($first: Int!, $skip: Int!) {
    posts(orderBy: date_DESC, first: $first, skip: $skip) {
      id
      slug
      title
      date
      excerpt
      mainArtwork {
        handle
      }
    }
    postsConnection {
      aggregate {
        count
      }
    }
  }
`;

export const postsQueryVars = {
  skip: 0,
  first: POSTS_PER_PAGE,
};

export default graphql(posts, {
  options: {
    variables: postsQueryVars,
    notifyOnNetworkStatusChange: true,
  },
  props: ({ data }) => ({
    data,
    loadMorePosts: () => {
      return data.fetchMore({
        variables: {
          skip: data.posts.length,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }
          return Object.assign({}, previousResult, {
            // Append the new posts results to the old one
            posts: [...previousResult.posts, ...fetchMoreResult.posts],
          });
        },
      });
    },
  }),
})(Resources);



// WEBPACK FOOTER //
// ./src/components/screens/Resources/Resources.jsx